<template>
    <tr class="item-row">
        <td class="delete" v-if="!readonly"></td>
        <td></td>
        <td></td>
        <td>{{ item.name }}</td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right"></td>
        <td class="text-right" title="Subtotal">€ {{ numberFormat }}</td>
    </tr>
</template>

<script>
export default {

    props: {
        item: {
            required: true
        },
        readonly: {
            default: false
        }
    },

    data() {
        return {
            initialized: false
        }
    },

    computed: {

        numberFormat() {
            let val = parseFloat(this.item.price).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }


}
</script>

